import { Injectable } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import { R3DirectiveMetadata } from '@angular/compiler';

export class EntPreStudentCollegeList
{
  StudentCourseID: number;
  StudentID: number;
  RegFromNo: number;
  CourseID: number;
  BranchID: number;
  EntDepID: number;
  SeatNo: number;
  EntCoScheduleID: number;
  Fees: number;
  CollegeID: number;
  RoundNo: number;
  AllotmentDate: Date;
  JoiningDate: Date;
  AdmCatID: number;
  EntCenterID: number;   
  CreatedLoginID: number;
  UpdatedDate: Date;
  UpdatedLoginID: number;
  StudentName: string;
  StudentSexCode: string;
  StudentCount: number;
  CentreName: string;
  CourseCode: string;
  CourseName: string;
  CourseShortName: string;
  BranchCode: string;
  BranchName: string;
  CollegeCode: string;
  CollegeName: string;
  CollegeName2: string;
  RegFormNo: number;
  PRNNO: string;
  CenterName: string;
  AllotmentFlag: string;
  CollegeName1: string;
  SocialReservationName: string;
  CasteCode: string;
  StudentMobileNo: string;
  StudentMailID: string;
  OnlinePaymentConfirmFlag: string;
  UTYStatus: string;
  RegConfirmFlag: string;
  EntranceExamFlag: number;
  AdmissionMethod: string;
  FeesAmount: number

  strApplayMsg:string;
  status:boolean;
  PaymentFlag:string;
  EndDate:string;
  MediumID:number;
  Medium:string;
  htmlcontent:string;
  StudentType:string;
}
export class PreStudentOtherInfo
{
  PreviousExamID:number;
  EducationalStreamID: number;  
}
export class CourseType
{
  CourseTypeID:number;
  CourseTypeName: string;  
}
export class PreProspectTrClass
{
  StuPoartlaID:number;
  ProspectusID: number;  
  FilePathCourseProspectus:string;
  CourseProspectusAmount:number=0.00;
  CourseID:number;
  CourseName:string;
  PaymentFlag:string;
  ViewDisable:boolean;
  paymentdis:boolean;
  prospectshow:number;
}
export class ColCourseInstr
{
  AcademicInstanceID:number;
  CollegeID:number;
  CourseID:number;
  BranchID:number;
  MediumID:number;
}
export class ScheuldeData
{
  CourseID:number;
  BranchID:number;
  ScheduleFlag: string;  
}
export class EntPreStudentCourseCheckAlreadyPresent
{
  StudentCourseID:number;
}
@Injectable({
  providedIn: 'root'
})
export class CourseselectionService {

  constructor(private dataService: DataAccessService) 
  {  }

  public getdata(QualifiedExamID,StreamID, CourseID,BranchID,StudentID,AcademicInstanceID) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetElgibleStudentCourseListForAdmission?QualifiedExamID='+ QualifiedExamID + '&StreamID='+ StreamID +'&CourseID='+ CourseID +'&BranchID='+ BranchID + '&StudentID=' + StudentID + '&AcademicInstanceID='+AcademicInstanceID; 
    return this.dataService.getAll<EntPreStudentCollegeList[]>()
  }
  public getdataforcollegecourse(QualifiedExamID,StreamID, CourseID,BranchID,StudentID,AcademicInstanceID,CollegeID) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetElgibleStudentCourseListForAdmissionForCollegeCourse?QualifiedExamID='+ QualifiedExamID + '&StreamID='+ StreamID +'&CourseID='+ CourseID +'&BranchID='+ BranchID + '&StudentID=' + StudentID + '&AcademicInstanceID='+AcademicInstanceID + '&CollegeID=' + CollegeID +''; 
    return this.dataService.getAll<EntPreStudentCollegeList[]>()
  }
  public getdataforcollegecourseOnlyView(QualifiedExamID,StreamID, CourseID,BranchID,StudentID,AcademicInstanceID,CollegeID) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetElgibleStudentCourseListForAdmissionForCollegeCourseOnlyView?QualifiedExamID='+ QualifiedExamID + '&StreamID='+ StreamID +'&CourseID='+ CourseID +'&BranchID='+ BranchID + '&StudentID=' + StudentID + '&AcademicInstanceID='+AcademicInstanceID + '&CollegeID=' + CollegeID +''; 
    return this.dataService.getAll<EntPreStudentCollegeList[]>()
  }
  public getdataforcollegecourseprospectus(QualifiedExamID,StreamID, CourseID,BranchID,StudentID,AcademicInstanceID,CollegeID) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetElgibleStudentCourseListForAdmissionForCollegeCourseprospectus?QualifiedExamID='+ QualifiedExamID + '&StreamID='+ StreamID +'&CourseID='+ CourseID +'&BranchID='+ BranchID + '&StudentID=' + StudentID + '&AcademicInstanceID='+AcademicInstanceID + '&CollegeID=' + CollegeID +''; 
    return this.dataService.getAll<EntPreStudentCollegeList[]>()
  }
  public getotherinfo(StudentID) {debugger
    this.dataService.setControllerName = '/PreStudentOtherInfo/';
    this.dataService.setMethodName = 'GetPreStudentOtherInfoByStudentIDForAdmissionForm?StudentID='+ StudentID  ; // setting method name from API controller
    return this.dataService.getAll<PreStudentOtherInfo[]>()
  }
  public GetCheckAlreadyPresent(CourseID,BranchID,StudentID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetCheckAlreadyPresent?CourseID=' + CourseID + '&BranchID=' + BranchID + '&StudentID='+ StudentID  ; // setting method name from API controller
    return this.dataService.getAll<EntPreStudentCourseCheckAlreadyPresent[]>()
  }
  public GetCheckScheduleForDirect(CourseID,BranchID,AcademicInstanceID,StudentType) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetCheckScheduleForDirect?CourseID=' + CourseID + '&BranchID=' + BranchID + '&AcademicInstanceID='+AcademicInstanceID + '&StudentType=' + StudentType + '';
    return this.dataService.getAll<ScheuldeData[]>()
  }
  public GetStudentTypeOfStudentForPortal(StudentID, CourseID, BranchID, AcademicInstanceID, CollegeID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetStudentTypeOfStudentForPortal?StudentID=' + StudentID  + '&CourseID=' + CourseID + '&BranchID=' + BranchID + '&AcademicInstanceID='+AcademicInstanceID + '&CollegeID=' + CollegeID + '';
    return this.dataService.getAll<ScheuldeData[]>()
  }
  public GetCheckScheduleForCET(CourseID,BranchID,AcademicInstanceID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetCheckScheduleForCET?CourseID=' + CourseID + '&BranchID=' + BranchID + '&AcademicInstanceID='+AcademicInstanceID;
    return this.dataService.getAll<ScheuldeData[]>()
  }
  public GetBasicCourseTypeList() {
    this.dataService.setControllerName = '/BasicCourseType/';
    this.dataService.setMethodName = 'GetBasicCourseTypeList?CourseTypeID=0';
    return this.dataService.getAll<CourseType[]>()
  }
  public GetCheckPurchaseProspectus(StuPoartlaID,AcademicInstanceID,CollegeID) {
    this.dataService.setControllerName = '/PreProspectTr/';
    this.dataService.setMethodName = 'GetCheckPurchaseProspectus?StuPoartlaID=' + StuPoartlaID + '&AcademicInstanceID=' + AcademicInstanceID + '&CollegeID='+ CollegeID + '';
    return this.dataService.getAll<PreProspectTrClass[]>()
  }
  public GetCollegeProspectPaymentReceipt(StuPoartlaID,AcademicInstanceID,CollegeID,PaymentType) {
    this.dataService.setControllerName = '/PreProspectTr/';
    this.dataService.setMethodName = 'GetCollegeProspectPaymentReceipt?StuPoartlaID=' + StuPoartlaID + '&AcademicInstanceID=' + AcademicInstanceID + '&CollegeID='+ CollegeID + '&PaymentType='+PaymentType+'';
    return this.dataService.getAll<PreProspectTrClass[]>()
  }
  public GetCourseDetailsForProspectus(CourseTypeID,StuPoartlaID,AcademicInstanceID,CollegeID) {
    this.dataService.setControllerName = '/PreProspectTr/';
    this.dataService.setMethodName = 'GetCourseDetailsForProspectus?CourseTypeID=' + CourseTypeID + '&StuPoartlaID=' + StuPoartlaID + '&AcademicInstanceID='+ AcademicInstanceID + '&CollegeID=' + CollegeID + '';
    return this.dataService.getAll<PreProspectTrClass[]>()
  }
  public PostInsertPreProspectTr(data) {
    this.dataService.setControllerName = '/PreProspectTr/';
    this.dataService.setMethodName = 'PostInsertPreProspectTr'; // setting method name from API controller.
    return this.dataService.add<PreProspectTrClass[]>(data)
  }
  public GetBasicColCourseInstrListForPortalAdmission(AcademicInstanceID,CollegeID,CourseID,BranchID,MediumID) {
    this.dataService.setControllerName = '/BasicColCourseInstr/';
    this.dataService.setMethodName = 'GetBasicColCourseInstrListForPortalAdmission?AcademicInstanceID=' + AcademicInstanceID + '&CollegeID=' + CollegeID + '&CourseID='+ CourseID + '&BranchID=' + BranchID + '&MediumID=' + MediumID + '';
    return this.dataService.getAll<ColCourseInstr[]>()
  }
  public GetScheduleCheckForDirectAdmission(CollegeID, AcdYrID, CourseID, CoursePartID, BranchID, StudentType) {
    this.dataService.setControllerName = '/AcademicInstanceSchedule/';
    this.dataService.setMethodName = 'GetScheduleCheckForDirectAdmission?CollegeID=' + CollegeID + '&AcdYrID=' + AcdYrID + '&CourseID='+CourseID + '&CoursePartID='+ CoursePartID +'&BranchID='+ BranchID + '&StudentType=' + StudentType + '';
    return this.dataService.getAll<ScheuldeData[]>()
  }
}
